// ============================================================
// CropTool.jsx — rail panel for the Crop tab
// ------------------------------------------------------------
// Picks an aspect-ratio preset (the geometry lives in EditorCanvas, which is
// the only place with the rendered stage dimensions) and resets the crop.
// The draggable/resizable crop box itself is rendered over the photo by
// EditorCanvas when the Crop tab is active.
// ============================================================

import React from 'react';

// Keys must match aspectRatio() in EditorCanvas.
const ASPECTS = [
  { key: 'original', label: 'Original' },
  { key: '1:1',      label: '1:1' },
  { key: '4:5',      label: '4:5' },
  { key: '9:16',     label: '9:16' },
  { key: '16:9',     label: '16:9' },
  { key: 'free',     label: 'Freeform' },
];

export default function CropTool({ aspect, onAspect, onReset }) {
  return (
    <div>
      <div className="pe-field-label">Aspect ratio</div>
      <div className="pe-style-grid">
        {ASPECTS.map((a) => (
          <button
            key={a.key}
            className={`pe-style-chip${aspect === a.key ? ' active' : ''}`}
            onClick={() => onAspect(a.key)}
          >
            {a.label}
          </button>
        ))}
      </div>

      <p className="pe-crop-hint">
        Drag the box or its handles on the photo to frame your crop. Text stays
        pinned to the original photo, so anything outside the box is trimmed.
      </p>

      <button className="pe-btn pe-btn-ghost pe-btn-block" onClick={onReset}>
        Reset crop
      </button>
    </div>
  );
}
